import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import BackgroundTheme from "../../../Common/P2P/Header/BackgroundTheme";
import { getLenderAgreementReques } from '../LenderAgreement/laActions';

const LDCTerms = (props: any) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getLenderAgreementReques());
  }, [])

  const { lenderResponse,} = useSelector((state: any) => state.lenderAgreement);

  function createMarkup() {
    return {__html: lenderResponse && lenderResponse};
  }

  return (
    <BackgroundTheme>
       <div dangerouslySetInnerHTML={createMarkup()} />
    </BackgroundTheme>
  );
};

export default LDCTerms;